// Sonar/client/widgets/ActiveMonitorsSummaryWidget.js
export default {
    name: "ActiveMonitorsSummaryWidget",
    type: "MultiDisplayWidget",
    description: "Displays a summary of active monitors and recent alerts.",
    roles: ["appUser"], // Only for regular users
    widget: {
        title: "Sonar Status",
        size: "medium",
        dataProvider: {
            main: {
                rpc: "SonarAnalyticsRpc.getSummary"
            }
        },
        items: [
            { label: "Active Monitors", valueField: "activeMonitors", format: "number", icon: "bi bi-binoculars-fill" },
            { label: "Alerts This Month", valueField: "alertsThisMonth", format: "number", icon: "bi bi-bell-fill" }
        ]
    }
};